var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBigQuery = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "google-bigquery",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_597",
    "data-name": "Group 597",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2069",
    "data-name": "Path 2069",
    d: "M18.919,35.318v3.945a7.365,7.365,0,0,0,2.565,2.61V35.318Z",
    transform: "translate(-11.824 -22.074)",
    fill: "#aecbfa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2070",
    "data-name": "Path 2070",
    d: "M31.558,25.639V36.933a11.43,11.43,0,0,0,1.665.09,12.06,12.06,0,0,0,1.5,0V25.639Z",
    transform: "translate(-19.724 -16.024)",
    fill: "#669df6",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2071",
    "data-name": "Path 2071",
    d: "M46.558,39.437v4.935a7.5,7.5,0,0,0,2.55-2.73v-2.2Z",
    transform: "translate(-29.099 -24.648)",
    fill: "#aecbfa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2072",
    "data-name": "Path 2072",
    d: "M59.092,56.962l-2.13,2.13a.63.63,0,0,0,0,.9l5.31,5.31a.63.63,0,0,0,.885,0L65.3,63.156a.63.63,0,0,0,0-.885l-5.31-5.31a.63.63,0,0,0-.9,0",
    transform: "translate(-35.483 -35.483)",
    fill: "#4285f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2073",
    "data-name": "Path 2073",
    d: "M13.5,0A13.5,13.5,0,1,0,27,13.5,13.5,13.5,0,0,0,13.5,0m0,23.534A10.019,10.019,0,1,1,20.6,20.6a10.019,10.019,0,0,1-7.1,2.934",
    transform: "translate(0 0)",
    fill: "#669df6",
    fillRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBigQuery);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bigQuery.ba9736a4cd56878f077b39cae5093d8b.svg";